import React, { memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { styled } from '@material-ui/core/styles';
import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';

const CustomIconButton = styled(IconButton)(({ theme }) => ({
  fontSize: '1rem',
  '&:hover': {
    color: theme.palette.primary.main,
    backgroundColor: 'transparent'
  },
  '&:focus': {
    color: theme.palette.primary.main
  }
}));

const ChevronLeftIconButton = memo<IconButtonProps>(props => (
  <CustomIconButton {...props}>
    <SvgIcon viewBox="0 0 256 512" fontSize="inherit">
      <path d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z" />
    </SvgIcon>
  </CustomIconButton>
));

const ChevronRightIconButton = memo<IconButtonProps>(props => (
  <CustomIconButton {...props}>
    <SvgIcon viewBox="0 0 256 512" fontSize="inherit">
      <path d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z" />
    </SvgIcon>
  </CustomIconButton>
));

export { ChevronLeftIconButton, ChevronRightIconButton };
